'use strict'

var RES_IMG_SWIPPER
var SHARING_POP
var REVIEWS_POP

$(document).ready(function(){
    get_restaurant_images()

    resume_opened_tab()

    init_main_tabs_events()

    init_restaurant_image_uploader()

    show_order_reviews()

    modal_show_request_working()

   // get_google_yelp_rating()

    render_restaurant_sharing()

    if($("#modal-share-to-my-friends").length)
        $("#modal-share-to-my-friends").iziModal()

    setTimeout(() => {
      number_order_reviews()
    }, 400);

    estimate_time_order()

    init_temporary_menu()

})


// *****************************************************************************************
// LIST OF FUNCTIONS
// *****************************************************************************************

function init_restaurant_image_uploader() {
    //  init amazon upload and callback------------------------------------
    if (window && window.$amazon) {
        window.$amazon.callback['restaurant'] = function () {
            var venueId = $('#venueId').val();
            let data = {
                venueId: venueId,
                images: window.$amazon.urls
            }
            $.ajax({
                url: '/upload-restaurant-images',
                method: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data),
            })
                .then((res) => {
                    update_restaurant_images(res.data);
                })
        };
    }

    $('#upload-restaurant-image').unbind('click').on('click', function (e) {
        e.preventDefault();
        window.$amazon.type = 'restaurant';
        window.$amazon.frame = 2.63 / 1
        window.$amazon.size = 3000000
        $(window.$amazon.input).click();
    })

    $('#zoom-in-image').on('click', function () {
        if (!RES_IMG_SWIPPER) return false
        let slide_index = RES_IMG_SWIPPER.activeIndex
        let $imgs = RES_IMG_SWIPPER.$el.find('.swiper-slide').find('img')
        let imgs = []
        $.each($imgs, function (index, elem) {
            let img = {
                src: $(elem).attr('src'),
                w: 900,
                h: 300
            }
            imgs.push(img)
        })
        $.each($imgs, function (index, elem) {
            let img_tag = new Image();
            img_tag.onload = function () {
                imgs[index].w = this.width
                imgs[index].h = this.height
                if (index == slide_index) zoom_in_photos(imgs, slide_index)
            }
            img_tag.src = $(elem).attr('src')
        })
    })

    $('#remove-restaurant-image').on('click', function () {
        let slide_index = RES_IMG_SWIPPER.activeIndex;
        let $wrapper = $(RES_IMG_SWIPPER.slides).parent();
        let $item = $wrapper.find('.swiper-slide-active');
        let selectedImage = $item.find('img');
        if (!selectedImage) return
        let data = {
            img_url: selectedImage.attr('src'),
            venue_id: $('#venueId').val()
        }
        Swal.fire({
            title: "Are you sure to remove this image?",
            html: `<img src="${data.img_url}" style="width: 300px">`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ok",
            confirmButtonColor: "#3cb371",
            cancelButtonText: "No",
            closeOnCancel: true
        }).then((result) => {
            if (!result.isConfirmed) {
                return true
         }
            return $.ajax({
                url: '/remove-restaurant-image',
                method: 'POST',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(data),
                dataType: 'json',
            }).then(function (res) {
                RES_IMG_SWIPPER.removeSlide(slide_index)
                return toastr.success("Removed the photo");
            })
                .catch(err => { return })
        });
    })

    $('#set-image-default').on('click', function () {
        const venue_id = $('#venueId').val()
        let slide_index = RES_IMG_SWIPPER.activeIndex
        let $wrapper = $(RES_IMG_SWIPPER.slides).parent();
        let $item = $wrapper.find('.swiper-slide-active');
        let newDefaultImageUrl = $item.find('img').attr('src');

        let mitid = $('#menuItemId');
        let menuitemId = null;
        if (mitid && mitid.innerText) menuitemId = mitid.innerText
        let data = { imageUrl: newDefaultImageUrl, itemId: menuitemId, venueId: venue_id, isRemove: false };
        return $.ajax({
            url: '/setDefaultItemImage',
            method: 'POST',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            error: function (errorMSG) {
                Swal.fire({
                    title: "Could not set default image",
                    text: "Something went wrong when trying to change default image " + errorMSG,
                    icon: "error",
                });
            }
        }).then(function () {
            RES_IMG_SWIPPER.slideTo(slide_index)
            return toastr.success("Successfully");
        });
    })

}


function update_restaurant_images(data) {
    if (!_.size(data)) return false;
    let slides = []
    _.forEach(data, (item) => {
        let slide = `
                <div class="swiper-slide">
                    <img src="${item.url}" style="height: 100%; width: 100%; object-fit: cover;">
                </div>
            `
        slides.push(_.trim(slide))
    });
    RES_IMG_SWIPPER.prependSlide(slides)
    RES_IMG_SWIPPER.update()
    RES_IMG_SWIPPER.slideTo(0)
}

function get_restaurant_images(){
    let venueId = $('#venue-id').text().trim();
    let itemId = $('#menuItemId').length ? $('#menuItemId').html().trim() : venueId;
    let imageType = $('#menuItemId').length ? 'Menu Item' : 'Restaurant';
    let loadImages = '/fetchItemImages';

    //Gets the images for the restaurant and add it to the picture slider
    $.get(loadImages, { itemId: itemId, imageType: imageType, venueId: venueId })
    .done(function(imageData) {
        try {
            imageData = JSON.parse(JSON.stringify(imageData))
            console.log("imageData====",imageData)
            
             if(typeof (imageData.links) =='undefined'){
                imageData=JSON.parse((imageData));
             }
            console.log("_.valuesIn(imageData.links)[0]====",_.valuesIn(imageData.links)[0])
            return render_restaurant_images(_.valuesIn(imageData.links)[0])
        } catch (error) {
            console.log('render-restaurant-iamges', error)
        }
    });
}

function render_restaurant_images(data) {

    const isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);
    function render_images(images) {
        let html = ``;
        console.log("images===",images)
        if(typeof (images) =='undefined' || !Array.isArray(images) || images.length === 0){
             html += `
                    <div class="swiper-slide" style="width: 100%;">
                        <img loading="lazy" src="/images/tempfoodnotext.png" alt="Restaurant Photo" class="swiperMobilImg" style="border-radius: 10px; height: 395px; width: 100%; object-fit: cover;">
                    </div>`;
        }else{
            images = images.sort((a, b) => {
                if (b.isDefault === true && a.isDefault !== true) {
                  return 1;
                } else if (a.isDefault === true && b.isDefault !== true) {
                  return -1;
                } else {
                  return 0;
                }
              });
              
             _.forEach(images, image => {
                  // Menu images carousel UI
                if (!(isMobile || $(window).width() < 480)){ // carousel desktop ui
                    html += `
                    <div class="swiper-slide" style="width: 100%;">
                        <img loading="lazy" src="${image && image.url ? image.url :'/images/tempfoodnotext.png'}" alt="Restaurant Photo" class="swiperMobilImg" style="border-radius: 10px; height: 400px; width: 100%; object-fit: cover;">
                    </div>
                `;
                 } else { 
                       html += `
                    <div class="swiper-slide" style="width: 100%;">
                        <img loading="lazy" src="${image && image.url ? image.url :'/images/tempfoodnotext.png'}" alt="Restaurant Photo" class="swiperMobilImg" style="border-radius: 10px; height: 250px; width: 100%; object-fit: cover;">
                    </div>
                `;
               } 
            })
        }
        return html
    }
    console.log("data====",data)
    let swiper_html = `
            <div class="swiper" id="restaurant-image-carousel">
                <div class="swiper-wrapper" style="width: 100%;">
                    ${render_images(data)}
                </div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-prev" style="margin-left: 10%; background-color: rgba(255, 255, 255, 0.8); border-radius:5px;padding:9px 15px 20px 7px; display:${data && data.length>0 ? 'block' :'none'}">
                    <i class="fa fa-chevron-left fa-2x" aria-hidden="true" style="color: #4A4A4A"></i>
                </div>
                <div class="swiper-button-next" style="margin-right: 10%; background-color: rgba(255, 255, 255, 0.8); border-radius:5px;padding:9px 15px 20px 7px;display:${data && data.length>0 ? 'block' :'none'}">
                    <i class="fa fa-chevron-right fa-2x" aria-hidden="true" style="color: #4A4A4A"></i>
                </div>
            </div>
        `;

    $('#restaurant-presentation').html(swiper_html)

    return RES_IMG_SWIPPER = new Swiper('#restaurant-image-carousel', {
        slidesPerView: 1,
        spaceBetween: 5,
        freeMode: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    })
}

function zoom_in_photos(photos = [], img_index = 0) {
    let pswpElement = document.querySelectorAll('.pswp')[0];
    let options = {
        index: img_index,
        bgOpacity: 0.7
    };
    let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, photos, options);
    gallery.init();
}

function init_main_tabs_events() {
    $('.open-restaurant-menu, .open-restaurant-about, .open-restaurant-orders').on('click', function (e) {
        let el = e.target
        if (!$(el).hasClass('open-restaurant-menu')) hide_menu_items()
        $('.rest_btn_container').find('a').removeClass('active')
        $(this).addClass('active')
        $('.navigation-tab').hide('slow')
        let elem = $(this).data('point-to')
        $(elem).show('fadeIn')
        let page_log = {}
        try {
            page_log = JSON.parse(localStorage.page_log)
        } catch (err) {

        }
        page_log.open_tab = elem
        localStorage.page_log = JSON.stringify(page_log)
        setTimeout(() => {
            rerender_navbar();
        }, 400);
    })
}

function estimate_time_order() {
    let delivery_term = $('p#delivery-term').text().trim();
    let pickup_term = $('p#pickup-term').text().trim();
    let delivery_time = '';
    let pickup_time = '';
    let min_time, max_time;

    try {
      if(delivery_term){
        delivery_term = JSON.parse(delivery_term);
        if (delivery_term.deliveryMinTime && delivery_term.deliveryMaxTime) {
            min_time = Number(delivery_term.deliveryMinTime);
            if (min_time < 60) {
                delivery_time += `${min_time} min`
            } else {
                delivery_time += `${parseFloat(min_time / 60).toFixed(1)} hrs`;
            }
            max_time = Number(delivery_term.deliveryMaxTime);
            if (max_time < 60) {
                delivery_time += ` - ${max_time} min`
            } else {
                delivery_time += ` - ${parseFloat(max_time / 60).toFixed(1)} hrs`;
            }
        }
      } else {
        console.log("no delivery term in estimate_time_order");
      }
    } catch (error) {
        console.log("estimate_time_order parsing error...",error)
    }
    $('#estimate-delivery-time').text(`${delivery_time || '45 mins - 1 hour'} delivery`)

    try {
      if(pickup_term){
        pickup_term = JSON.parse(pickup_term);
        if (pickup_term.pickupMinTime && pickup_term.pickupMaxTime) {
            min_time = Number(pickup_term.pickupMinTime);
            if (min_time < 60) {
                pickup_time += `${min_time} min`
            } else {
                pickup_time += `${parseFloat(min_time / 60).toFixed(1)} hrs`;
            }
            max_time = Number(pickup_term.pickupMaxTime);
            if (max_time < 60) {
                pickup_time += ` - ${max_time} min`
            } else {
                pickup_time += ` - ${parseFloat(max_time / 60).toFixed(1)} hrs`;
            }
        }
      } else {
        console.log("no pickup term in estimate_time_order");
      }
    } catch (error) {
        console.log(error)
    }
    $('#estimate-pickup-time').text(`${pickup_time || '15 - 20 mins'} pickup`)

}


// function get_google_yelp_rating() {
//     let venueParams = {
//         name: $('#venue-name').text().trim(),
//         slug: $('#venue-slug').val(),
//         location: $('#venue-location').text().trim(),
//         lat: $('#venue-lat').text().trim(),
//         lng: $('#venue-lng').text().trim(),
//         phone: $('#venue-phone').text().trim(),
//         venueId: $('#venue-id').text().trim()
//     };
//     return $.promisedAjax({
//         url: '/yelpdata',
//         data: venueParams
//     })
//         .then(({ yelp, google }) => {
//             if (google && google.rating) render_google_rating(google)
//             if (yelp && yelp.foundBusiness) {
//                 var business = yelp.yelpRestaurantData;
//                 if (business.rateandreview) render_yelp_raring(business)
//             }
//         })
//         .catch((error) => {
//             return false
//         })
// }

function render_google_rating(data){
    let userRatingsTotal = data.userRatingsTotal || data.user_ratings_total
    let ratingImg = '';
    let has_half_star = (data.rating * 10) % 10;
    let star_count = Math.floor(data.rating);
    if (has_half_star) {
        ratingImg = `/images/yelp-images/google_star_${star_count}_half.png"`;
    } else {
        ratingImg = `/images/yelp-images/google_star_${star_count}.png"`;
    }
    let html = `
        <div class="d-flex align-items-center">
            <img class="mr-1" style="height: 15px;" src="${ratingImg}"/>
            <span class="yelp-rating-count mr-1" style="color:#000000!important;">${userRatingsTotal || 0}</span>
            Google
        </div>
    `;
    $('#google-rating').html(html)
}


function render_yelp_raring(data){
    let ratingImg = '';
    let has_half_star = (data.rating * 10) % 10;
    let star_count = Math.floor(data.rating);
    if(has_half_star) {
        ratingImg = `/images/yelp-images/extra_large_${star_count}_half.png"`;
    } else {
        ratingImg = `/images/yelp-images/extra_large_${star_count}.png"`;
    }
    let html = `
        <div class="d-flex align-items-center">
            <img class="mr-1" style="height: 15px;" src="${ratingImg}"/>
            <span class="yelp-rating-count mr-1" style="color:#000000!important;">${data.review_count || 0} </span>
            <img src="/images/yelp-images/yelp_logo_small.png" style="height: 20px" />
        </div>
    `;
    $('#yelp-rating').html(html)
}


function copyToClipboard(string) {
    let textarea;
    let result;
    try {
        textarea = document.createElement('textarea');
        textarea.setAttribute('readonly', true);
        textarea.setAttribute('contenteditable', true);
        textarea.style.position = 'fixed';
        textarea.value = string;

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();

        const range = document.createRange();
        range.selectNodeContents(textarea);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        textarea.setSelectionRange(0, textarea.value.length);
        result = document.execCommand('copy');
    } catch (err) {
        console.error(err);
        result = null;
    } finally {
        document.body.removeChild(textarea);
    }

    if (!result) {
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
        result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
        if (!result) {
            return false;
        }
    }
    return true;
}

function getDataShare($this) {
    let image = $('#restaurant-presentation').find('img').eq(0).attr('src')
    let text = $('#venue-name').text().trim()
    let venueId = $('#venue-id').text().trim()
    let url = window.location.hostname + "/restaurant/" + $('#venue-slug').val();

    let data = {
        image: image,
        hastag: "",
        text: text,
        venueId: venueId,
        menuItemId: '',
        url: url
    };
    return data;
}


function init_sharing(){
    let html = `
        <div class="card card-body">
            <a href="javascript:void(0)" class="d-flex align-items-center share-restaurant-via-friend hvr-grow" data-venuemenudata="<%= JSON.stringify(venue_infor) %>" data-sharetype="restaurant">
                <img src="/images/share/Platerate.svg" alt="" class="" style="max-height: 30px;">
                <span style="color: black;">Platerate</span>
            </a>
            <a href="javascript:void(0)" class="d-flex align-items-center mt-3 copy-link-to-clipboard hvr-grow" data-type="restaurant" >
                <img src="/images/share/link_icon.svg" alt="" class="mr-2" style="max-height: 30px;">
                <span style="color: black;">Copy Link</span>
            </a>
            <a href="javascript:void(0)" class="d-flex align-items-center mt-3 share-restaurant-via-facebook hvr-grow">
                <img src="/images/share/Facebook.png" alt="" class="mr-2" style="height: 30px;">
                <span style="color: black;">Facebook</span>
            </a>
            <a data-pin-do="buttonBookmark" data-pin-tall="true" href="javascript:void(0)" data-type="restaurant" class="d-flex mt-3 align-items-center share-restaurant-via-pinterest hvr-grow">
                <img src="/images/share/Pinterest.png" alt="" class="mr-2" style="height: 30px;">
                <span style="color: black;">Pinterest</span>
            </a>
            <a href="javascript:void(0)" class="d-flex mt-3 align-items-center share-restaurant-via-mail hvr-grow" data-type="restaurant">
                <img src="/images/share/Mail.png" alt="" class="mr-2" style="height: 30px;">
                <span style="color: black;">Mail</span>
            </a>
            <a href="javascript:void(0)" class="d-flex mt-3 align-items-center share-restaurant-via-twitter hvr-grow">
                <img src="/images/share/Twitter.png" alt="" class="mr-2" style="height: 30px;">
                <span style="color: black;">Twitter</span>
            </a>
            <input type="hidden" class="restaurant-review-image" value="">
        </div>
    `;
    $('#list-platforms').html(html)

    $('.share-restaurant-via-friend').on('click', function (e) {
        let venueData = $(this).data('venuemenudata');
        let sharetype = $(this).attr('data-sharetype');
        $('#modal-share-to-my-friends').find('.share-mail-for-friend').data('venuedata', venueData)
        $('#modal-share-to-my-friends').find('.share-mail-for-friend').attr('data-sharetype', sharetype )
        shareOnPlaterate();
    });
    var referrer_id =$("#referrer_id").val();
    $('.copy-link-to-clipboard').on('click', function(){

        let venue_slug = $('#venue-slug').val()
        let url_type = $(this).data('type')
        let url_copied = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':'+ window.location.port : ''}/restaurant/${venue_slug}`
        if(url_type == 'menu-item') {
            item_slug = $(this).parent().find('.item-slug').val()
            url_copied += `?menuItem=${item_slug}&referrerId=${referrer_id}`
        }else {
            url_copied += `?referrerId=${referrer_id}`
        }

        let isCopy = copyToClipboard(url_copied);
        if(isCopy){
            toastr.success('The link is copied')
        }
        $('#restaurant-sharing').trigger('click')
    })

    $('.share-restaurant-via-facebook').on('click', function (e) {
        let data = getDataShare();
        shareOnFacebook(data.url, data, 520, 350);
        $('#restaurant-sharing').trigger('click')
    });
    $('.share-restaurant-via-twitter').on('click', function (e) {
        let data = getDataShare();
        shareOnTwitter(data.url, data, 520, 350);
        $('#restaurant-sharing').trigger('click')
    });
    $('.share-restaurant-via-linkedin').on('click', function (e) {
        let data = getDataShare();
        shareOnlinkedin(data.url, data, 520, 350);
        $('#restaurant-sharing').trigger('click')
    });
    $('.share-restaurant-via-mail').on('click', function (e) {
        let data = getDataShare();
        let venue_slug = $('#venue-slug').val()
        let url_type = $(this).data('type')
        let url_copied = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':'+ window.location.port : ''}/restaurant/${venue_slug}`
        if(url_type == 'menu-item') {
            item_slug = $(this).parent().find('.item-slug').val()
            url_copied += `?menuItem=${item_slug}&referrerId=${referrer_id}`
        }else{
            url_copied += `?referrerId=${referrer_id}`
        }
        shareOngooglePlus(url_copied, data, 520, 350);
        $('#restaurant-sharing').trigger('click')
    });
    $('.share-restaurant-via-pinterest').on('click', function (e) {
        let data = getDataShare();
        let venue_slug = $('#venue-slug').val()
        let venueId = $('#restaurant-venueId').val()
        let url_type = $(this).data('type')
        let url_copied = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':'+ window.location.port : ''}/restaurant/${venue_slug}`
        if(url_type == 'menu-item') {
            item_slug = $(this).parent().find('.item-slug').val()
            url_copied += `?menuItem=${item_slug}&referrerId=${referrer_id}`
        }else{
            data.image = $('#restaurant-photo').val()
        }
        let url_share_image = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}${window.location.port ? ':'+ window.location.port : ''}/images/serve-ss-image?venueId=${venueId}&url=${data.image}&type=${url_type}`);
        window.open( `https://www.pinterest.com/pin/create/button/?url=${url_copied}&media=${url_share_image}&description=hfhfhf`,"platerate","width=520,height=350");
        console.log("url_copied--===",url_copied)
    });
}

function render_restaurant_sharing() {
  let button = document.querySelector(`#restaurant-sharing`);
  let tooltip = document.querySelector(`#social-platform`);
  let position = 'right-start'
  if(screen.width <= 576) position = 'left-start'
  SHARING_POP = new Popper(button, tooltip, {
    placement: position,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      },
    ],
  })
  $('#restaurant-sharing').on('click', function(){
      SHARING_POP.update()
      if($(this).data('status') == 'hidden') {
          $(this).data('status', 'show')
          $('#social-platform').find('#list-platforms').show()
      } else {
        $(this).data('status', 'hidden')
        $('#social-platform').find('#list-platforms').hide()
      }
  })
  $('#list-platforms').hide()
  init_sharing()
}
$(window).on("click.Bst", function(event){
    if ( $('#social-platform').has(event.target).length == 0 && !$('#social-platform').is(event.target) && $('#restaurant-sharing').has(event.target).length == 0){
        $('#restaurant-sharing').data('status', 'hidden');
        $('#social-platform').find('#list-platforms').hide();
    }
});
// function isShowSelectOrderType(){
//   $.ajax({
//   url: '/platerateadmin/getsettings',
//   method: 'GET',
//   dataType: 'json',
//   }).then(function (res) {
//       if (res.code == 0 && res.data) {
//           if(res.data.showOrderType){
//             __isSelectOrderType=true;
//           }else{
//             __isSelectOrderType=false;
//           }
//       }
//   }).catch(function (error) {
//     __isSelectOrderType=true;
//   });
// }
function modal_show_request_working(){
    let req
    req = $('#not-work-yet').val()
    if(req == 'false') return true
    try {
        req = JSON.parse(localStorage.request_to_work)
    }catch (err){
        req = []
    }
    let venue_id = $('#venueId').val()
    if(req.includes(venue_id)) return true
    let screen_width = screen.width
    let html = `
        <div id="modal-request-working">
            <div class="ml-5 mr-5 mt-5 mb-3">
                <div class="d-flex justify-content-between aligt-center">
                    <div class="d-flex justify-content-start">
                        <img src="/images/logo-no-name.png" style="height: 30px">
                        <div class="font-weight-bold" style="color:green; font-size: 23px">Plate</div>
                        <div class="font-weight-bold" style="font-size: 23px">Rate</div>
                    </div>
                    <div>
                        <i class="fa fa-times" aria-hidden="true" style="color: green" data-izimodal-close=""></i>
                    </div>
                </div>
            </div>
            <div class="text-center w-100" style="color: green; font-size: ${screen_width <= 540 ? '30px' : '40px'}; position: absolute">Want a <strong>60%</strong> credit here?</div>
            <img class="mt-3" src="/images/request_to_work.png"/ style="width: 100%">
            <div>
                <div class="text-center" style="font-size: 28px;">Request this restaurant</div>
                <div class="text-center" style="font-size: 28px;">partner with PlateRate</div>
                <div class="form-row mt-4 ml-5 mr-5 mb-5">
                    <div class="col-6 pl-md-4 pr-md-4 text-center">
                        <button class="btn btn-lg btn-block btn-outline-danger font-weight-bold" style="font-size: 30px" data-izimodal-close="">No</button>
                    </div>
                    <div class="col-6 pl-md-4 pr-md-4 text-center">
                        <button class="btn btn-lg btn-block btn-success font-weight-bold request-to-work" style="font-size: 30px">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    `;
    $('body').append(html)
    $("#modal-request-working").iziModal({
        onClosed: function(){
            let req
            try {
                req = JSON.parse(localStorage.request_to_work)
            }catch (err){
                req = []
            }
            let venue_id = $('#venueId').val()
            req.push(venue_id)
            return localStorage.request_to_work = JSON.stringify(req)
        },
    });

    $('.request-to-work').on('click', function(){
        request_to_work()
    })
    $("#modal-request-working").iziModal('open');

    function request_to_work(){
        let venueId =  $("#venueId").val();
        $.ajax({
            url: '/salescrm/requestrestaurant',
            method: 'POST',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({ venueId: venueId }),
            dataType: 'json',
            error: function (err) {
                return toastr.success('Request failed! Please try again')
            },
            success: function (data) {
                $("#modal-request-working").iziModal('close');
                return toastr.success('Request successfully! PlateRate will partner ASAP.')
            }
        })
      }
}

function hide_menu_items(){
    $(".menu-section-collapse").each(function(index, item){
        if($(item).data('index') > 0) $(item).hide()
    })
}
function resume_opened_tab(){
    if(!window.location.href.includes('/restaurant/') && $('#userId').val()) return true
    let page_log = {}
    try{
        page_log = JSON.parse(localStorage.page_log)
    }catch(err){}
    if(window.location.href.includes('/restaurant/') && !$('#userId').val()) {
      page_log.open_tab = '#restaurant-menu'
    }
    let open_tab = page_log.open_tab
    if(!open_tab) open_tab = '#restaurant-menu'
    $('.rest_btn_container').find('a').removeClass('active')
    $('.rest_btn_container').find(`a[data-point-to="${open_tab}"]`).addClass('active')
    _.forEach(['#restaurant-menu', '#restaurant-about', '#restaurant-orders', '#modal-all-my-order'], item => {
        if(item != open_tab) return $(item).hide()
        $(item).show()
    })
}
let number_order_reviews = ()=> {
    let data = {
        venue_id: $('#venueId').val()
    }
    $.ajax({
        url: "/restaurant/number-order-reviews",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        success: function (res) {
          console.log("in /restaurant/number-order-reviews...", res);
          let count = 0;
          let jres = null;
          try{
            jres = JSON.parse(`${res}`);
          } catch(err){
//            console.log("jres error...", err);
          }
          if(res && res.data) count = res.data
          else if(jres && jres.data) count = jres.data
//          else if(res && res.includes('{"data":')) count = res.replace('{"data":',"").replace('}',"") /* hack when redis returns follows which is not a json though -  {"data":5} */
            $('#logoPLReview').show();
          $('#id-number-order-reivews').text(`${count} PlateRate Reviews`)
        },
        error: function (e) {
          return false;
        }
    })
}

let show_order_reviews = ()=> {
    let data = {
        venue_id: $('#venueId').val()
    }
    $.ajax({
        url: "/restaurant/list-order-reviews",
        type: "POST",
        contentType: "application/json; charset=utf-8",
		dataType: 'json',
        data: JSON.stringify(data),
        success: function (res) {
            let isPartneredRestaurant = $('#not-work-yet').val()
            if(isPartneredRestaurant != "true")
                render_restaurant_reviews(res)
        },
        error: function (e) {
          return false;
        }
    })
}


var ranging_title = {
    ratingValue: {title: 'Overall' ,range: ['Very bad', 'Average', 'Very good']},
    temperatureOfFood: {title: 'Temperature of food' ,range: ['Very bad', 'Average', 'Very good']},
    deliveryRatingValue: {title: 'Delivery time', range: ['>1 hour late', 'Average', '>20 mins early']},
    serviceRating: {title: 'Service',range: ['Very bad', 'Average', 'Very good']},
    noiseLevelRating: {title: 'Noise Level', range: ['Very bad', '', 'Very Good']},
    ambienceRating: {title: 'Ambiance', range: ['Low', '', 'High']},
    cleaniness: {title: 'Restaurant Cleanliness', range: ['Dirty', '', 'Very Clean']}
}
function render_rating_bar(infor,itemDetails,keyCollapse){
    let html = ``
    let i = 0;
    _.forIn(ranging_title, (elem, key) => {
        if(!_.hasIn(infor, key) || (keyCollapse == "pickup" && key == "deliveryRatingValue")) return
        i++;
        html+= i == 2 ? `<div class='collapse form-row col-12 reviews-type pr-0' data-order-type='${keyCollapse}' id='collapse-reviews-type-${keyCollapse}'>` : "";
        html+= `
        <div class="col-md-6">
            <div class="w-100">
            <div class="font-weight-bold">${elem.title}</div>
                <input type="range" min="1" max="100" value="${infor[key]}" data-value="${infor[key]}" class="m-slider" style="height: 9px !important;">
            </div>
            <div class="d-flex justify-content-between">
                <div style="font-size: 12px;color: #9F9F9F">${elem.range[0]}</div>
                <div style="font-size: 12px;color: #9F9F9F">${elem.range[1]}</div>
                <div style="font-size: 12px;color: #9F9F9F">${elem.range[2]}</div>
            </div>
        </div>`
    })

    if(i >= 2){
        html+= `
        <div class="col-12 mt-4 see-review-title" data-toggle="collapse" href="#review-key-details-${keyCollapse}" role="button" aria-expanded="false" aria-controls="review-key-details-${keyCollapse}" style="margin-left: 1px;">
            <a href="javascript:void(0)" class="show-list-reviews" style="color: #4F4F4F;font-size: 12px;">
            See All Reviews <i class="fas fa-chevron-down float-right mt-1"></i>
            </a>
        </div>
    </div>`;
    }else{
        html+= `
        <div class='collapse form-row col-12  mt-4 reviews-type see-review-title' data-order-type='${keyCollapse}' id='collapse-reviews-type-${keyCollapse}'>
            <div class="col-12" data-toggle="collapse" href="#review-key-details-${keyCollapse}" role="button" aria-expanded="false" aria-controls="review-key-details-${keyCollapse}">
                <a href="javascript:void(0)" class="show-list-reviews" style="color: #4F4F4F;font-size: 12px;">
                See All Reviews <i class="fas fa-chevron-up float-right mt-1"></i>
                </a>
            </div>
        </div>`;
    }

    html+= `
    <div class="collapse details-list-review" id="review-key-details-${keyCollapse}" style="width: 100%;">
        <div class="px-2 pt-3 mt-1" style="max-height: 50vh; width: 100%; overflow-y: auto; background-color: white;width: 99%;margin-left: 1px;">
            ${render_particular_review(itemDetails, keyCollapse)}
        </div>
        <div class="blur-div"></div>
    </div>
    <div class="text-center mt-3 col-12" data-toggle="collapse" id="title-review-${keyCollapse}" href="#collapse-reviews-type-${keyCollapse}" role="button" aria-expanded="false" aria-controls="collapse-reviews-type-${keyCollapse}">
        <a href="javascript:void(0)" class="show-list-reviews" style="margin-top: 10px !important; border: 1px solid green; padding: 5px 55px; color: green;border-radius:5px;">View All Ratings</a>
    </div>`;
    return html
}
function render_rating_bar_detail(infor, keyCollapse){
    let html = ``
    _.forIn(ranging_title, (elem, key) => {
        if(!_.hasIn(infor, key) || (keyCollapse == "pickup" && key == "deliveryRatingValue")) return
        html += `
            <div class="col-md-6">
                <div class="w-100">
                <div class="font-weight-bold">${elem.title}</div>
                    <input type="range" min="1" max="100" value="${infor[key]}" data-value="${infor[key]}" class="m-slider" style="height: 9px !important;">
                </div>
                <div class="d-flex justify-content-between">
                    <div style="font-size: 12px;color: #9F9F9F">${elem.range[0]}</div>
                    <div style="font-size: 12px;color: #9F9F9F">${elem.range[1]}</div>
                    <div style="font-size: 12px;color: #9F9F9F">${elem.range[2]}</div>
                </div>
            </div>
        `
    })
    return html
}
//
function render_particular_review(infor, keyCollapse){
    let html = ``
    _.forEach(infor, item => {
        let nameArr = item && item.userName ? item.userName.split(" ") : [];
        let userName = nameArr && nameArr[0] ? nameArr[0].concat(' ', nameArr[1] ? nameArr[1].slice(0, 1) + '.' : '') : '';

        let userId = item.userId;
        html += `
            <div class="mb-3">
                <div class="m-card mt-3" style="margin: 0 !important; padding: 0 !important">
                    <div class="form-row p-3">
                        <div class="col-3 col-md-2">
                            <img src="${item.user_infor.imageUrl || '/images/avatar.png'}" style="width: 70px; height: 70px; border-radius: 50%;"></img>
                        </div>
                        <div class="col-9 mt-0 col-md-10" style="margin-top: 13px">
                            <div class="pl-0 pt-0 pb-2 font-weight-bold form-inline justify-content-between" style="color: green">
                                <a href="/publicprofile/${userId}" style="font-size: 18px; color: #4A4A4A;">${userName}</a>
                                <div class="" style="font-size: 11px; color: #02843D">${moment(item.dateUpdated).format('MM/DD/YYYY')}</div>
                            </div>
                            <div class="form-row">
                                ${render_rating_bar_detail(item, keyCollapse)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `
    })
    return html
}

let init_reviews_pop = () => {
    let button = document.querySelector(`#show-restaurant-reviews`);
    let tooltip = document.querySelector(`#list-restaurant-reviews`);
    REVIEWS_POP = new Popper(button, tooltip, {
        placement: 'top-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
        ],
    })
}

let render_restaurant_reviews = (data)=>{
    let screen_width = screen.width
    let html = `
        <div class="form-inline justify-content-between align-items-center">
            <div style="display: flex;width: 100%;justify-content: space-between; padding-right:-5px; background-color: #B9B9B9;">
                <button style="border: none;" class="btn btn-sm btnBgColor btn-success choose-order-type mr-1 btn-bigz" data-type="pickup">Pickup</button>
                <button style="border: none" class="btn btn-sm btnBgColor btn-success choose-order-type mr-1 btn-bigz" data-type="delivery">Delivery</button>
                <button style="border: none; outline: none" class="btn btn-sm btnBgColor btn-success choose-order-type btn-bigz" data-type="order-ahead">Order Ahead</button>
            </div>
        </div>
    `;
    _.forIn(data, (item, key) => {
        if(!_.size(item)) return html += `
            <div class="reviews-for-orders reviews-for-${key} m-3" style="display: none">
                No orders yet
            </div>
        `;

         {/* <div class="p-2 font-weight-bold" style="background-color: #E8ECEA; color: black">Summary of ${item.num} reviews</div>
        */} html += `
            <div class="reviews-for-orders reviews-for-${key}" style="${screen_width <= 576 ? '' :  'min-width: 95%;'}">
                <div class="" style="margin: 0 !important; padding: 2.4% !important">

                    <div class="p-1">
                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="w-100">
                                    <div for="overall-rating" class="font-weight-bold">Overall rating</div>
                                    <input type="range" min="1" max="100" value="${item.overall}" data-value="${item.overall}"  class="m-slider" id="overall-rating" style="height: 9px !important;">
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div style="font-size: 12px;color: #9F9F9F"">Very bad</div>
                                    <div style="font-size: 12px;color: #9F9F9F"">Average</div>
                                    <div style="font-size: 12px;color: #9F9F9F"">Very good</div>
                                </div>
                            </div>
                            ${render_rating_bar(item.cre_overall,item.details,key)}
                        </div>
                    </div>
                </div>
            </div>
        `;
    })
    html = `
        <div class="card" style="border-radius: 8px; min-width: 300px">
            ${html}
        </div>
    `;


    let $popper = $("#list-restaurant-reviews")
    // $popper.show()
    $popper.html(html)

    $popper.find('.choose-order-type').on('click', function(){
        $popper.find('.choose-order-type').removeClass('btn-success')
        $(this).addClass('btn-success')
        let order_type = $(this).data('type')
        $popper.find('.reviews-for-orders').hide('fadeOut')
        $popper.find(`.reviews-for-${order_type}`).show('fadeIn')
        $("#total-review-social").show();
    })
    $popper.find('.choose-order-type').eq(0).trigger('click')
    $popper.find(".m-slider").on('input',function (e) {
        let value = $(this).data('value')
        $(this).val(value)
        let val = (value - $(this).attr('min')) / ($(this).attr('max') - $(this).attr('min'));
        let percent = val * 100;

        $(this).css('background-image',
            '-webkit-gradient(linear, left top, right top, ' + 'color-stop(' + percent + '%, green), ' + 'color-stop(' + percent + '%, lightgrey)' + ')');

        $(this).css('background-image',
            '-moz-linear-gradient(left center, green 0%, green ' + percent + '%, lightgrey ' + percent + '%, lightgrey 100%)');
    });
    $popper.find(".m-slider").trigger('input')
    $(".reviews-type").on('show.bs.collapse', function(e) {
        let orderType= $(this).data('order-type');
        $(`#title-review-${orderType} a`).text('Hide All Ratings')
    });
    $(".reviews-type").on('hide.bs.collapse', function(e) {
        let orderType= $(this).data('order-type');
        $(`#review-key-details-${orderType}`).collapse('hide');
        $(`#title-review-${orderType} a`).text('View All Ratings')
    });
    $('.show-list-reviews').parent().on('click', function(){
        $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
    })
    $("#list-restaurant-reviews").on('show.bs.collapse', function(e) {
        $(this).removeClass('d-none')
        $('#show-restaurant-review').find('span').toggleClass('fa-chevron-down fa-chevron-up');
    });
    $("#list-restaurant-reviews").on('hide.bs.collapse', function(e) {
        $('#show-restaurant-review').find('span').toggleClass('fa-chevron-down fa-chevron-up');
    });
    $(".details-list-review").on('show.bs.collapse', function(e) {
        $("#total-review-social").hide();
    });
    $(".details-list-review").on('hide.bs.collapse', function(e) {
        $("#total-review-social").show();
    });
}

// ****************************************************************************************************************************************************
function change_zoom_cursor(elem) {
    let img_link = $(elem).find('.item.active').find('img').attr('src');
    let cursor_icon, cursor_color;
    if (_.includes(img_link, '/images/')) {
        cursor_icon = '\uf093';
        cursor_color = 'green'
    } else {
        cursor_icon = '\uf00e';
        cursor_color = '#FFCC00'
    }
    let canvas = document.createElement("canvas");
    canvas.width = 24;
    canvas.height = 24;
    //document.body.appendChild(canvas);
    let ctx = canvas.getContext("2d");
    ctx.fillStyle = cursor_color;
    ctx.font = "24px FontAwesome";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(cursor_icon, 12, 12);
    let dataURL = canvas.toDataURL('image/png')
    $(elem).css('cursor', 'url(' + dataURL + '), auto');
}
function render_images_slider_zoom(elem) {
    let html = '';
    elem.each(function (ind, item) {
        let imageUrl = $(item).find('img').attr('src');
        html += `
        <div class="carousel-item  text-center ${$(item).hasClass('active') ? 'active' : ''}">
            <img class="carousel-image" src="${imageUrl}" style="width: 100%;" alt="Item Image">
        </div>`;
    })
    return html;
}
// ****************************************************************************************************************************************************
var TEMPORARY_PHOTOS = []

function init_temporary_menu(){
    let element = $('#temporary-menu')
    if(!element || !element.length) return true
    $('#remove-temporary-image').iziModal()
    render_temporary_menu()
    return get_temporary_photos()
}
function get_temporary_photos(){
    let data = {
        venue_id: $('#venueId').val()
    }
    return $.ajax({
        url: '/get-temporary-menu-images',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
    })
    .then((res)=> {
        TEMPORARY_PHOTOS = res
        render_list_temporary_photos()
    })
}

function remove_temporary_photos(img){
    let data = {
        venue_id: $('#venueId').val(),
        img_url: img
    }
    return $.ajax({
        url: '/remove-temporary-menu-images',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
    })
    .then((res)=> {
        $('#remove-temporary-image').iziModal('close')
        toastr.success('Removed photos completely')
        return get_temporary_photos()
    })
    .catch(err=>{
        console.log(err)
    })
}

function render_photos(images) {
    let carousel = ''
    _.forEach(images, (img, index) => {
        carousel += `
            <div class="carousel-item ${!index ? 'active' : ''}">
                <img src="${img.url}" class="d-block w-100" alt="...">
            </div>
        `
    })
    let key = Math.random().toString(36).substring(2)
    return `
        <div id="carousel-${key}" class="images-of-menu-item carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                ${carousel}
            </div>
            <a class="carousel-control-prev" href="#carousel-${key}" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carousel-${key}" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
            </a>
        </div>
    `;
}


function zoom_in_photos(photos = [],img_index = 0) {
    let pswpElement = document.querySelectorAll('.pswp')[0];
    let options = {
        index: img_index,
        bgOpacity: 0.7
    };
    let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, photos, options);
    gallery.init();
}

function render_list_temporary_photos(){
    let html = ''
    if(!_.size(TEMPORARY_PHOTOS)) {
        html = `
            <div class="form-inline justify-content-center mb-7">
                <div class="text-center" style="width: 300px; height: 100px; color: white;">
                    <button type="button" class="btn btn-success show-if-user" id="firstUploadImage" style="margin-bottom: 5px; display: none">Be the first to upload a Menu Photo!</button>
                </div>
            </div>
        `
        $('#show-list-temporary-photos-uploaded').html(html)
        $('#firstUploadImage').on('click', function(){
            $('#upload-photos').click();
        })
        return
    }

    _.forIn(TEMPORARY_PHOTOS, (images, menu) => {
        let div_key = Math.random().toString(36).substring(2)
        html += `
            <div class="col-12 col-md-4 form-group" id="menu-image-${div_key}">
                ${render_photos(images)}
                <div class="form-inline justify-content-between">
                    <div class="h4">${menu}</div>
                    <a href="javascript:void(0)" class="h6 text-danger remove-temporary-image" data-key="${div_key}" style="display: none">Remove image</a>
                </div>
            </div>
        `
    })
    $('#show-list-temporary-photos-uploaded').html(html)
    let user_permission = $('#userPermissions')
    if(user_permission.length){
        user_permission = user_permission.val()
        if(user_permission.includes('Restaurant Admin') || user_permission.includes('Salesperson')) $('#show-list-temporary-photos-uploaded').find('.remove-temporary-image').show()
    }
    $('#show-list-temporary-photos-uploaded').find('.remove-temporary-image').on('click', function () {
        let menu_key = $(this).data('key')
        let $menu = $(`#menu-image-${menu_key}`)
        let img = $menu.find('.carousel-item.active').find('img').attr('src')
        let $elem = $('#remove-temporary-image')
        $elem.find('img').css({'opacity': 1})
        $elem.find('.remove-image').on('click', function(){
            $elem.find('img').css({'opacity': 0.5})
            return remove_temporary_photos(img)
        })
        $elem.find('.image-removed').attr('src', img)
        $elem.iziModal('open')

    })
    $('#show-list-temporary-photos-uploaded').find('.carousel-inner').on('click', function () {
        let imgs = []
        let img_index = 0
        $.each($(this).find('img'), function(index, elem){
            let img = {
                src: $(elem).attr('src'),
                w: 900,
                h: 600
            }
            if($(elem).parent().hasClass('active')) img_index = index
            imgs.push(img)
        })
        return zoom_in_photos(imgs,img_index)
    })

}

function render_temporary_menu(){
    let html = `
        <div id="upload-temporary-menu">
            <div class="m-3">
                <div class="form-inline justify-content-between mb-3">
                    <div class="h4 font-weight-bold">Upload Photos</div>
                    <div class="hvr-grow" data-izimodal-close=""><i class="fa fa-times fa-2x" aria-hidden="true" style="color: grey"></i></div>
                </div>
                <div id="upload-area" class="text-center" style="height: 150px; background-color: #E9E9E9; align-content: center; display: grid;">
                    <i class="fa fa-camera fa-2x" aria-hidden="true"></i>
                    <div class="mt-3">Drag your photos or <a href="javascript:void(0)" id="upload-via-choosing">Browse</a></div>
                </div>
                <div id="photos-uploaded-successfully" class="d-flex justify-content-start mt-1" style="overflow-x: auto;">
                </div>
                <label class="mt-3">Menu name</label>
                <select id="selected-menu-name" class="custom-select custom-select-lg mb-3">
                    <option value="Common">Choose a menu</option>
                    <option value="Main Menu">Main Menu</option>
                    <option value="Dinner">Dinner</option>
                    <option value="Lunch">Lunch</option>
                    <option value="Breakfast">Breakfast</option>
                    <option value="Drinks">Drinks</option>
                </select>
                <div class="form-inline justify-content-end mt-3">
                    <button class="btn btn-success btn-lg" id="upload-temp-menu-photos">Upload</button>
                </div>
            </div>
        </div>
        <div class="container mt-5 d-none d-sm-block">
            <div class="form-inline justify-content-between">
                <div class="h4 font-weight-bold">Menu Photos</div>
                <button class="btn btn-success show-if-user" id="upload-photos" style="display: none">Upload Photos</button>
            </div>
            <hr class="mt-1">
            <div id="show-list-temporary-photos-uploaded" class="row">
            </div>
        </div>
    `
    let $elem = $('#temporary-menu')
    $elem.html(html)
    $elem.find('#upload-temporary-menu').iziModal({overlayClose: false})
    if($('#temporary-menu-upload').val() == 'true') $elem.find('.show-if-user').show()
    $elem.find('#upload-photos').on('click', function(){
        $(`#photos-uploaded-successfully`).html('')
        $('#upload-temporary-menu').iziModal('open')
    })
    bind_drag_event()
}
// ----------------------------------------------------------------------------------

function upload_temporary_menu_photos(){
    let data = {
        venue_id: $('#venueId').val(),
        images: uploaded_photos,
        menu_name: $('#selected-menu-name').val()
    }
    return $.ajax({
        url: '/upload-temporary-menu-images',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data),
    })
    .then(()=> {
        uploaded_photos = []
        $('#upload-temporary-menu').iziModal('close')
        toastr.success('Upload photos completely')
        return get_temporary_photos()
    })
}
// ----------------------------------------------------------------------------------

function bind_drag_event(){
    $("html").on("drop", function(e) {
        e.preventDefault();
        e.stopPropagation();
    });
    // --------------------------------------------------------

    let $elem = $('#upload-temporary-menu')
    $elem.on('drop', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $('#upload-temporary-menu').iziModal('close')
        window.$amazon.type = 'temporary_menu';
        window.$amazon.files = []
        var files = e.originalEvent.dataTransfer.files;
        window.$amazon.files = files
    });
    // --------------------------------------------------------

    $('#upload-via-choosing').on('click', function(e) {
        e.preventDefault();
        $('#upload-temporary-menu').iziModal('close')
        window.$amazon.type = 'temporary_menu';
        $(window.$amazon.input).click();
    })

    $('#upload-temp-menu-photos').on('click', function(){
        return upload_temporary_menu_photos()
    })
}

//
var uploaded_photos = []
window.$amazon.multiple = true;
window.$amazon.finished = () => {
    let html = ''
    _.forEach(uploaded_photos, photo =>{
        html += `<img src="${photo}" class="img-thumbnail mr-3" style="width: 100px !important;">`;
    })
    $(`#photos-uploaded-successfully`).prepend($(html))
    return $('#upload-temporary-menu').iziModal('open')
}
window.$amazon.callback['temporary_menu'] = function(){
    uploaded_photos = _.concat(uploaded_photos, window.$amazon.urls)
};
